import "./App.css";

import AppRoutes from "./Routes/Routes";

function App() {
  return (
    <>
      <AppRoutes />
    </>
  );
}

export default App;
